/* Single source of truth for the engineer-led (FDE) offer.
   Change prices here only. */
export const OFFER = {
  startingPrice: "$1,500",
  startingPriceNum: 1500,
  priceLine: "From $1,500/mo",
  term: "3 months",
  summary: "From $1,500/mo · live in days · scoped on a call",
  minimumTerm: "3-month initial term",
  phases: [
    { t: "Day 1 · Learn your business", b: "Your engineer embeds with your team and maps where AI creates real leverage." },
    { t: "Week 1 · First workflows live", b: "Eva, your company brain, and the workflows around them — built for how you operate." },
    { t: "Weeks 2–12 · Expand & train", b: "Live on your channels, integrated with your tools, your team trained." },
    { t: "Ongoing · Run", b: "Your AI-enhanced business keeps running. Your engineer stays on call." },
  ],
} as const;
